// extracted by mini-css-extract-plugin
module.exports = {"top":"_1w439LN75V","form-price":"_1-k1LuYCym","width-160":"_1RE9zuW5BC","content":"_20-Z_Qm35Z","sort":"_3iDLQKFvq4"};